import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_TEMAS_ACADEMICOS = 'ALL_TEMAS_ACADEMICOS';
export const LOADING_ALL_TEMAS_ACADEMICOS = 'LOADING_ALL_TEMAS_ACADEMICOS';
export const ACTIVO_TEMAS_ACADEMICOS = 'ACTIVO_TEMAS_ACADEMICOS';
export const PARAMS_TEMAS_ACADEMICOS = 'PARAMS_TEMAS_ACADEMICOS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const temasAcademicosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_TEMAS_ACADEMICOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_TEMAS_ACADEMICOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_TEMAS_ACADEMICOS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_TEMAS_ACADEMICOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
